import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaTruck, FaHardHat, FaIndustry, FaFileContract, FaBuilding,
} from 'react-icons/fa';
import AnimateOnScroll from './AnimateOnScroll';

const INDUSTRIES = [
  { key: 'logistics', icon: <FaTruck size={22} /> },
  { key: 'fieldOps', icon: <FaHardHat size={22} /> },
  { key: 'industrial', icon: <FaIndustry size={22} /> },
  { key: 'insurance', icon: <FaFileContract size={22} /> },
  { key: 'construction', icon: <FaBuilding size={22} /> },
];

const Industries = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20" style={{ background: '#f8f9fe' }} id="industries">
      <div className="container">
        <AnimateOnScroll>
          <div className="text-center mb-14">
            <p className="t-h1">{t('Industries.label')}</p>
            <h2 className="t-h2 max-w-2xl mx-auto">{t('Industries.title')}</h2>
            <p className="t-p max-w-xl mx-auto">{t('Industries.subtitle')}</p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <AnimateOnScroll key={ind.key} animation="fadeUp" delay={i * 50}>
              <div
                className="p-6 rounded-2xl bg-white border transition-all duration-300 hover:shadow-md h-full text-center"
                style={{ borderColor: '#e5e7eb' }}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4"
                  style={{ background: '#f0f2ff', color: '#010C66' }}
                >
                  {ind.icon}
                </div>
                <h3
                  className="font-semibold text-sm"
                  style={{ fontFamily: '"Wix Madefor Display", sans-serif', color: '#010C66' }}
                >
                  {t(`Industries.${ind.key}`)}
                </h3>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        <AnimateOnScroll animation="fadeUp" delay={200}>
          <div className="text-center mt-12">
            <Link
              to="/#contact"
              className="inline-flex items-center gap-2 rounded-lg px-6 py-3 text-sm font-semibold transition-all duration-200 hover:opacity-90"
              style={{ background: '#00C9B1', color: '#010C66', fontFamily: '"Inter", sans-serif' }}
            >
              {t('Industries.cta')}
            </Link>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default Industries;
